import { styled } from '@mui/material';

import { CallHistoryRowProps } from './CallHistoryRow.types';

interface CallHistoryRowDivProps {
  showCallActionButton?: boolean;
  durationWithCallButtonClass?: React.CSSProperties
};

export const Styles = {
  row: {},
  avatar: {
    width: '30px',
    height: '30px',
    borderRadius: '50%',
  },

  statusColumn: { alignItems: 'center', justifyContent: 'center', width: 15, height: 21},
  colourDot: { width: 10, height: 10, alignItems: 'center', justifyContent: 'center'},
  flagIcon: {
    marginRight: '4px !important',
    width: 24,
    height: 24,
    backgroundColor: '#50CF97',
  },
  callMediumIcon: {
    backgroundColor: '#4c94ba',
    width: 32,
    height: 32,
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#FFFFFF',
  },
  durationText: { maxWidth: '100%' },
  columnDurationWithCallButton: {
    flex: 1,
    display: 'flex',
  },
  columnNavigation: {
    width: (props: CallHistoryRowProps<any>) => props.miniVersion ? 30 : 90,
    marginLeft: '3%',
  },
  showOnHover: {
    opacity: 0,
    marginLeft: '6%',
  },
  rowOnHover: {
    '&:hover': {
      cursor: 'pointer',
      '& > div:last-child': {
        opacity: 1,
      },
    },
  },
  contactNameText: {
    color: '#414141',
    fontSize: '16px',
    fontWeight: 700,
    letterSpacing: '1px',
  },
  timestamp: {
    color: '#919191',
    fontSize: '16px',
    fontWeight: 500,
    letterSpacing: '1px',
  },
};

export const DurationDiv =  styled('div', {
  shouldForwardProp: (prop) => prop !== 'durationWithCallButtonClass',
})<CallHistoryRowDivProps>(({ durationWithCallButtonClass }) => ({
  flex: 1,
  display: 'flex',
  justifyContent: 'flex-end',
  marginRight: '8px',
  ...durationWithCallButtonClass
}));

export const DropdownButtonDiv =  styled('div', {
  shouldForwardProp: (prop) => prop !== 'showCallActionButton',
})<CallHistoryRowDivProps>(({ showCallActionButton }) => ({
  display: showCallActionButton ? 'none' : 'initial',
}));

export const ContactNameTimestampContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  maxWidth: '168px',
  minWidth: '168px',
  paddingLeft: '15px',
});
export const ContactNameDiv = styled('div')({
  display: 'flex',
  alignItems: 'center',
  width: '100%',
});
export const TimestampDiv = styled('div')({
  display: 'flex',
  alignItems: 'center',
  width: '100%',
});
export const ColumnActionsDiv = styled('div')({
  display: 'flex',
});
export const CallHistoryRowDiv = styled('div')({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  height: 60,
  paddingLeft: 8,
  margin: '0px 4px 4px 4px',
  boxShadow: '0px 2px 48px 0px rgba(0, 0, 0, 0.04)',
  borderRadius: '10px',

  '&:hover': {
    cursor: 'pointer',

    '& > .durationDiv': {
      display: 'none',
    },
    '& > .dropdownButtonDiv': {
      flex:1,
      display: 'flex',
      justifyContent: 'flex-end'
    },
  },
});
